module.exports = __webpack_public_path__ + "img/公司优势.7ac95583.jpg";